import BackButton from "app/components/BackButton/BackButton";
import { ResponsiveScreenSizes } from "app/utils/const";
import { FormattedMessage } from "react-intl";
import Media from "react-media";
import { useHistory } from "react-router-dom";
import "./AccountHeader.scss";

const AccountHeader = ({ id }: { id: string }) => {
  const history = useHistory();
  return (
    <div className="account-header-container">
      <Media
        query={`(max-width: ${ResponsiveScreenSizes.mobile})`}
        render={() => (
          <div className="account-header">
            <div className="account-header__title">
              <BackButton className="" history={history} mobile={true} />
              <FormattedMessage tagName="span" id={id} />
              <div />
            </div>
          </div>
        )}
      />
      <Media
        query={`(min-width: ${ResponsiveScreenSizes.desktop})`}
        render={() => (
          <div className="account-header">
            <div className="account-header__title">
              <BackButton className="account-header__back" history={history} />
              <FormattedMessage tagName="span" id={id} />
              <div />
            </div>
          </div>
        )}
      />
    </div>
  );
};

export default AccountHeader;
